import { Injectable } from '@angular/core';
import { IUpdateNotificationPreferencesDTO, IUserNotificationPreference } from 'common_library';
import { HttpIoService } from '../communication/http-io.service';

const CONTROLLER_ROOT = 'me/notification-preferences';

@Injectable({ providedIn: 'root' })
export class NotificationPreferencesService {

  constructor(private HIO: HttpIoService) { }

  /** Stato corrente delle preferenze. `confirmed` è false se l'utente non le ha mai salvate. */
  async getMine(): Promise<IUserNotificationPreference & { confirmed: boolean }> {
    try {
      return await this.HIO.get<IUserNotificationPreference & { confirmed: boolean }>(CONTROLLER_ROOT);
    } catch (error) {
      console.log('🐱️ : error', error);
      return null;
    }
  }

  /** Salva le preferenze. Lascia propagare l'errore al chiamante (toast). */
  async updateMine(dto: IUpdateNotificationPreferencesDTO): Promise<IUserNotificationPreference> {
    return await this.HIO.put<IUserNotificationPreference, IUpdateNotificationPreferencesDTO>(CONTROLLER_ROOT, dto);
  }
}
